import { render, staticRenderFns } from "./Tour2.vue?vue&type=template&id=342a1676&scoped=true&"
import script from "./Tour2.vue?vue&type=script&lang=js&"
export * from "./Tour2.vue?vue&type=script&lang=js&"
import style0 from "./Tour2.vue?vue&type=style&index=0&id=342a1676&prod&lang=scss&scoped=true&"
import style1 from "./Tour2.vue?vue&type=style&index=1&id=342a1676&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342a1676",
  null
  
)

export default component.exports